import React from 'react';
import { Link } from 'react-router-dom';
import { SITE } from '../config/site';

export default function DeleteAccountPage() {
  const mailHref = `mailto:${SITE.contactEmail}?subject=${encodeURIComponent(
    'IšgerkVaistus – paskyros ištrynimas'
  )}&body=${encodeURIComponent(
    'Noriu ištrinti IšgerkVaistus paskyrą.\nEl. paštas, kuriuo registravausi:\n'
  )}`;

  return (
    <div className="page legal-page">
      <div className="card legal-card">
        <h1>Paskyros ištrynimas</h1>
        <p className="legal-meta">Programėlė „IšgerkVaistus“</p>

        <section>
          <h2>Kas ištrinama</h2>
          <p>
            Ištrynimas yra negrįžtamas. Pašaliname jūsų prisijungimo paskyrą,
            priminimus ir susijusią dienos istoriją. Tai nėra medicinos
            paslauga – ištriname tik programėlės paskyros duomenis.
          </p>
        </section>

        <section>
          <h2>Jei turite prenumeratą</h2>
          <p>
            Jei Stripe prenumerata vis dar aktyvi arba gali būti toliau
            apmokestinama, paskyros neištrinsime, kol jos nenutrauksite.
          </p>
          <p>
            Nutraukimas: atidarykite programėlę → Pagalba → Tvarkyti
            prenumeratą. Ten Stripe portale galite peržiūrėti ir nutraukti
            prenumeratą.
          </p>
        </section>

        <section>
          <h2>Kaip ištrinti programėlėje</h2>
          <ol>
            <li>Prisijunkite prie IšgerkVaistus.</li>
            <li>Eikite į Pagalba → Ištrinti paskyrą.</li>
            <li>Jei reikia, pirmiausia nutraukite prenumeratą.</li>
            <li>Patvirtinkite: „Ar tikrai norite ištrinti paskyrą?“</li>
          </ol>
        </section>

        <section>
          <h2>Kaip paprašyti ištrynimo el. paštu</h2>
          <p>
            Parašykite iš to el. pašto adreso, kuriuo registravotės:
          </p>
          <p>
            <a href={mailHref}>{SITE.contactEmail}</a>
          </p>
          <p>
            Laiške nurodykite, kad norite ištrinti IšgerkVaistus paskyrą.
            Patikrinę, kad laiškas siųstas iš jūsų paskyros adreso, atliksime
            ištrynimą pagal tas pačias taisykles (įskaitant prenumeratos
            patikrą).
          </p>
        </section>

        <section>
          <h2>Kontaktai</h2>
          <p>
            Pagalba:{' '}
            <a href={`mailto:${SITE.contactEmail}`}>{SITE.contactEmail}</a>
          </p>
          <p>
            Svetainė:{' '}
            <a href={SITE.url}>{SITE.url.replace('https://', '')}</a>
          </p>
        </section>

        <p className="legal-back">
          <Link to="/">← Pradžia</Link>
        </p>
      </div>
    </div>
  );
}
